import {
  imminentRegionsByAlpha2RegionCode,
  supportedRegionsByAlpha2RegionCode,
} from './regions'

export const supportedLanguagesByLocaleCode = {
  'en-GB': {
    flag: '🇬🇧',
    name: 'English',
    languageCode: 'en',
    localeCode: 'en-GB',
    country: supportedRegionsByAlpha2RegionCode['GB'],
    availableInProduction: true,
  },
  'en-US': {
    flag: '🇺🇸',
    name: 'English',
    languageCode: 'en',
    localeCode: 'en-US',
    country: supportedRegionsByAlpha2RegionCode['US'],
    availableInProduction: true,
  },
  'en-IE': {
    flag: '🇬🇧',
    name: 'English',
    languageCode: 'en',
    localeCode: 'en-IE',
    country: supportedRegionsByAlpha2RegionCode['IE'],
    availableInProduction: true,
  },
  'en-ES': {
    flag: '🇬🇧',
    name: 'English',
    languageCode: 'en',
    localeCode: 'en-ES',
    country: supportedRegionsByAlpha2RegionCode['ES'],
    availableInProduction: false,
  },
  'es-ES': {
    flag: '🇪🇸',
    name: 'Español',
    languageCode: 'es',
    localeCode: 'es-ES',
    country: supportedRegionsByAlpha2RegionCode['ES'],
    availableInProduction: false,
  },
} as const

/**
 * Imminent languages are not currently supported by the library, but
 * they might be in the future. To enable them, moving them into the
 * `supportedLanguagesByLocaleCode` object.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const imminentLanguagesByLocaleCode = {
  'nl-BE': {
    flag: '🇧🇪',
    name: 'Nederlands',
    languageCode: 'nl',
    localeCode: 'nl-BE',
    country: imminentRegionsByAlpha2RegionCode['BE'],
  },
  'bg-BG': {
    flag: '🇧🇬',
    name: 'Български',
    languageCode: 'bg',
    localeCode: 'bg-BG',
    country: imminentRegionsByAlpha2RegionCode['BG'],
  },
  'el-CY': {
    flag: '🇨🇾',
    name: 'Ελληνικά',
    languageCode: 'el',
    localeCode: 'el-CY',
    country: imminentRegionsByAlpha2RegionCode['CY'],
  },
  'cs-CZ': {
    flag: '🇨🇿',
    name: 'Čeština',
    languageCode: 'cs',
    localeCode: 'cs-CZ',
    country: imminentRegionsByAlpha2RegionCode['CZ'],
  },
  'da-DK': {
    flag: '🇩🇰',
    name: 'Dansk',
    languageCode: 'da',
    localeCode: 'da-DK',
    country: imminentRegionsByAlpha2RegionCode['DK'],
  },
  'et-EE': {
    flag: '🇪🇪',
    name: 'Eesti',
    languageCode: 'et',
    localeCode: 'et-EE',
    country: imminentRegionsByAlpha2RegionCode['EE'],
  },
  'fi-FI': {
    flag: '🇫🇮',
    name: 'Suomi',
    languageCode: 'fi',
    localeCode: 'fi-FI',
    country: imminentRegionsByAlpha2RegionCode['FI'],
  },
  'fr-FR': {
    flag: '🇫🇷',
    name: 'Français',
    languageCode: 'fr',
    localeCode: 'fr-FR',
    country: imminentRegionsByAlpha2RegionCode['FR'],
  },
  'hr-HR': {
    flag: '🇭🇷',
    name: 'Hrvatski',
    languageCode: 'hr',
    localeCode: 'hr-HR',
    country: imminentRegionsByAlpha2RegionCode['HR'],
  },
  'hu-HU': {
    flag: '🇭🇺',
    name: 'Magyar',
    languageCode: 'hu',
    localeCode: 'hu-HU',
    country: imminentRegionsByAlpha2RegionCode['HU'],
  },
  'is-IS': {
    flag: '🇮🇸',
    name: 'Íslenska',
    languageCode: 'is',
    localeCode: 'is-IS',
    country: imminentRegionsByAlpha2RegionCode['IS'],
  },
  'it-IT': {
    flag: '🇮🇹',
    name: 'Italiano',
    languageCode: 'it',
    localeCode: 'it-IT',
    country: imminentRegionsByAlpha2RegionCode['IT'],
  },
  'de-LI': {
    flag: '🇱🇮',
    name: 'Deutsch',
    languageCode: 'de',
    localeCode: 'de-LI',
    country: imminentRegionsByAlpha2RegionCode['LI'],
  },
  'lt-LT': {
    flag: '🇱🇹',
    name: 'Lietuvių',
    languageCode: 'lt',
    localeCode: 'lt-LT',
    country: imminentRegionsByAlpha2RegionCode['LT'],
  },
  'lv-LV': {
    flag: '🇱🇻',
    name: 'Latviešu',
    languageCode: 'lv',
    localeCode: 'lv-LV',
    country: imminentRegionsByAlpha2RegionCode['LV'],
  },
  'mt-MT': {
    flag: '🇲🇹',
    name: 'Malti',
    languageCode: 'mt',
    localeCode: 'mt-MT',
    country: imminentRegionsByAlpha2RegionCode['MT'],
  },
  'nl-NL': {
    flag: '🇳🇱',
    name: 'Nederlands',
    languageCode: 'nl',
    localeCode: 'nl-NL',
    country: imminentRegionsByAlpha2RegionCode['NL'],
  },
  'pl-PL': {
    flag: '🇵🇱',
    name: 'Polski',
    languageCode: 'pl',
    localeCode: 'pl-PL',
    country: imminentRegionsByAlpha2RegionCode['PL'],
  },
  'pt-PT': {
    flag: '🇵🇹',
    name: 'Português',
    languageCode: 'pt',
    localeCode: 'pt-PT',
    country: imminentRegionsByAlpha2RegionCode['PT'],
  },
  'ro-RO': {
    flag: '🇷🇴',
    name: 'Română',
    languageCode: 'ro',
    localeCode: 'ro-RO',
    country: imminentRegionsByAlpha2RegionCode['RO'],
  },
  'sv-SE': {
    flag: '🇸🇪',
    name: 'Svenska',
    languageCode: 'sv',
    localeCode: 'sv-SE',
    country: imminentRegionsByAlpha2RegionCode['SE'],
  },
  'sl-SI': {
    flag: '🇸🇮',
    name: 'Slovenščina',
    languageCode: 'sl',
    localeCode: 'sl-SI',
    country: imminentRegionsByAlpha2RegionCode['SI'],
  },
  'sk-SK': {
    flag: '🇸🇰',
    name: 'Slovenčina',
    languageCode: 'sk',
    localeCode: 'sk-SK',
    country: imminentRegionsByAlpha2RegionCode['SK'],
  },
} as const
